import { render, staticRenderFns } from "./ElibraryProdukHukumView.vue?vue&type=template&id=10a76c41&scoped=true"
import script from "./ElibraryProdukHukumView.vue?vue&type=script&lang=js"
export * from "./ElibraryProdukHukumView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a76c41",
  null
  
)

export default component.exports